import React, { Component } from 'react';
import { Affix, Layout as AntLayout } from 'antd';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import withStore from '@/store/withStore';
import Download from '../Download';
import AvatarImg from '../AvatarImg';
import SideMenu from '../SideMenu';
import AuthorizeWX from '../AuthorizeWX';
import style from './index.module.scss';
import { getUrlParam } from '@/utils/url';

const { Header, Content, Footer, Sider } = AntLayout;
const technicalSupportName = '丰赞科技';
// 没有侧边栏的页面们
const noSidePages = ['/account'];
// 是否有侧边栏
const pageHasSide = (pathname: string) => !noSidePages.includes(pathname);
type Props = any;
type State = any;

class Layout extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      prevPath: null,
    };
  }
  static getDerivedStateFromProps({ location }: Props, prevState: State) {
    const { pathname: nextPath } = location;
    if (nextPath === prevState.prevPath) return null;
    // 将页面滚动到底部
    window.scrollTo(0, 0);
    // 切换 UI
    return {
      prevPath: nextPath,
      hasSide: pageHasSide(nextPath),
    };
  }
  async componentDidMount() {
    // 获取用户信息，校验是否登录
    const {
      getAccountInfo,
      getShopData,
      checkOpenAccount,
      getLessonNoticeList,
      init,
      setIsIframe,
    } = this.props;
    // 处于店铺页面
    const { checkHD } = this.props;
    checkHD();
    await getAccountInfo();
    // 全局查看课程更新情况
    getLessonNoticeList();
    getShopData();
    init();
    const { isIframe } = getUrlParam();
    setIsIframe(isIframe);

    try {
      await checkOpenAccount();
    } catch (error) {}
  }

  render() {
    const { now, isGettingRightsLoading } = this.props;
    // 获取用户信息
    if (now.getAccountInfo) return <div className="loading" />;

    const { children } = this.props;
    const { hasSide } = this.state;

    const { location } = this.props;
    const { pathname } = location;
    // 没有 SideBar
    if (!hasSide) {
      return (
        <AntLayout className={`has-header ${pathname === '/account' ? 'account' : ''}`}>
          <Header>
            <AvatarImg />
          </Header>
          <Content>{children}</Content>
          <Footer style={{ textAlign: 'right' }}>
            <span>{`${technicalSupportName}提供技术支持`}</span>
          </Footer>
        </AntLayout>
      );
    }

    // 获取店铺信息
    if (now.getShopData || isGettingRightsLoading) return <div className="loading" />;

    const {
      // 通用
      history,
      sideMenu,

      isPolymer,
      shopType,
      showLogListDot,
      exportLogList,
      logListLoading,
      setLogListDot,
      getLogList,
      payNum,
      goodsNum,
      weAppAuthData,
      getWeAppAuthData,
      shopName,
      isIframe,
    } = this.props;
    return (
      <AntLayout>
        {isIframe !== '1' ? (
          <Sider width={176} className={style.siderBox}>
            <SideMenu
              sideMenu={sideMenu}
              shopType={shopType}
              payNum={payNum}
              goodsNum={goodsNum}
              history={history}
              polymerDefine={{ '/goods/group': '商品分组' }}
              isPolymer={isPolymer}
            />
          </Sider>
        ) : null}

        <AntLayout>
          {isIframe !== '1' ? (
            <Header style={{ position: 'sticky', top: 0, zIndex: 13 }}>
              <AuthorizeWX
                weAppAuthData={weAppAuthData}
                getWeAppAuthData={getWeAppAuthData}
                shopName={shopName}
              />
              <Download
                showLogListDot={showLogListDot}
                exportLogList={exportLogList}
                logListLoading={logListLoading}
                setLogListDot={setLogListDot}
                getLogList={getLogList}
              />
              <AvatarImg />
            </Header>
          ) : null}
          <Content>
            <div
              className={`${isIframe !== '1' ? style.contentBox : style.contentIframeBox}`}
              id="contentBoxId"
            >
              {children}
            </div>
          </Content>
        </AntLayout>
      </AntLayout>
    );
  }
}

export default withRouter(connect(...withStore('basic', 'welcome', 'settings'))(Layout));
